import './PriceGroup.less';
import React, {useState, useEffect} from 'react';
import Group from "../group/Group";
import NumberInput from "../../../../components/number-input/NumberInput";
import __ from "../../../../i18n";
import {CURRENCY_CODE, CURRENCY_SYMBOL} from "../../../../view-constants/currency";
import Button from "../../../../components/button/Button";


let autoIncId = 0;

export default function PriceGroup(
    {
        defaultMinPrice,
        defaultMaxPrice,
        forcedMinPrice = undefined,
        forcedMaxPrice = undefined,
        defaultCollapsed,
        apply = (minPrice, maxPrice) => {},
    }
) {

    const [minPrice, setMinPrice] = useState(defaultMinPrice);
    const [maxPrice, setMaxPrice] = useState(defaultMaxPrice);

    const checkError = () => {
        if (minPrice !== null && minPrice < 0) {
            return __('Min price cannot be less than :amount(CURRENCY)', {amount: 0});
        }

        if (maxPrice !== null && maxPrice < 1) {
            return __('Max price cannot be less than :amount(CURRENCY)', {amount: 1});
        }

        if (minPrice !== null && maxPrice !== null && minPrice > maxPrice) {
            return __('Min price cannot be greater than max price');
        }

        return null;
    };

    const error = checkError();

    const hasChange = minPrice !== defaultMinPrice || maxPrice !== defaultMaxPrice;

    const [refreshKey, setRefreshKey] = useState(autoIncId);

    return <Group
        title={__('Price range')}
        name="price"
        defaultCollapsed={defaultCollapsed}
    >
        <div className="inputs" key={refreshKey}>
            <NumberInput
                defaultValue={defaultMinPrice}
                value={forcedMinPrice}
                unit={CURRENCY_SYMBOL}
                onChange={setMinPrice}
            />
            <div className="linker">-</div>
            <NumberInput
                defaultValue={defaultMaxPrice}
                value={forcedMaxPrice}
                unit={CURRENCY_SYMBOL}
                onChange={setMaxPrice}
            />
        </div>
        {
            hasChange &&
            <div className="actions">
                <Button
                    title={__('Cancel')}
                    onClick={() => {
                        setMinPrice(defaultMinPrice);
                        setMaxPrice(defaultMaxPrice);
                        setRefreshKey(++autoIncId);
                    }}
                    appearance="neutral-text"
                    size="small"
                />
                <Button
                    title={__('Apply')}
                    disabled={error !== null}
                    tooltip={error}
                    onClick={() => apply(minPrice, maxPrice)}
                    appearance="primary"
                    size="small"
                />
            </div>
        }
    </Group>;
}
